var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',[_c('source',{attrs:{"srcset":_vm.bannerImage.mobile,"media":"(max-width: 767px)"}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.bannerImage.desktop,"alt":"","id":"banner-avaliacoes-home"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }